import React from 'react';
import { Text as RNText, TextProps as RNTextProps } from 'react-native';
import s, { getFontFamily } from './Typography.styles';

export type Title1Props = RNTextProps & {
  weight?: 'semibold' | 'bold';
};

export const Title1: React.FC<Title1Props> = ({
  children,
  weight = 'semibold',
  style,
  ...props
}) => {
  return (
    <RNText style={[s.common, s.title1, getFontFamily(weight), style]} {...props}>
      {children}
    </RNText>
  );
};
